
import { Component, OnInit, OnDestroy, AfterViewInit, AfterContentInit, AfterContentChecked, AfterViewChecked } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from "rxjs/operators";

import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { Address } from '../../../../common/models/address.model';
import { chiefsorderdetailsmodel, levelContext } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { lettercontentmodel } from '../../../../models/comodel/lettercontentmodel.model';
import { IReportContextValue, ChiefsOrderMergeConstants, ReportTemplate } from '../../../../models/comodel/mergefieldsmodel.model';
import { mergeFieldsOrgInfo } from '../../../../common/models/organization.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { deepClone } from '../../../../builder/models/editor.model';
import { tap } from 'rxjs/operators';
import { ReportSelectorService } from '../../../../form-controls/services/report-selector.service';

@Component({
    selector: 'co-level-mergefields',
    templateUrl: './co-level-mergefields.component.html',
    styleUrls: ['./co-level-mergefields.component.scss'],
    standalone: false
})
export class CoLevelMergeFieldsComponent implements OnInit, OnDestroy {

    sub: Subscription[] = [];
    orgId: string;
    categoryCode: string;
    chiefsOrderInstanceId: string;
    priorChiefsOrderNumber: string;
    finalStatusForPriorChiefsOrder: string;
    reportTemplate: ReportTemplate = { reportContextValues: [] } as ReportTemplate;
    org: mergeFieldsOrgInfo;
    mergeInfo: IReportContextValue[] = [];
    coInfo: levelContext = { data: {} as chiefsorderdetailsmodel};
    applicationNumber: string
    wellName: string;
    wellNumber: string;
    countyName: string;
    townshipName: string;
    bondNumber: string;
    bondInsuranceNumber: string;
    coNumber: string;
    coDate: string;
    receiptData: string;
    finalDate: string;
    titleText: string = '';
    dataIsSet: boolean = false;
    letter: lettercontentmodel = {
        id: '',
        htmlContent: ''
    }

    subHeader: SubHeader = new SubHeader({ title: this.titleText });

    mergeFieldsForm: FormGroup;   

    nextDialog: Dialog = new Dialog("Once you move forward, you will still be able to edit the letter, but you cannot return to this page. Please make sure the values entered are correct. Are you sure you want to proceed?",
        [
            new DialogButton("Continue", true, () => this.onNextDialogConfirm()),
            new DialogButton("Cancel", false, () => this.onNextDialogCancel()),
        ]);

    constructor(
        private activeRoute: ActivatedRoute,
        private chiefsOrderService: ChiefsOrderService,
        private reportTemplateService: ReportSelectorService,
        private readonly loader: LoaderService,
        private subHeaderService: SubHeaderService,
        public dialogService: DynamicDialogService,
        public router: Router
    ) {
        this.mergeFieldsForm = new FormGroup({});
        let applicationNumberControl = new FormControl(this.applicationNumber);
        applicationNumberControl.disable();
        this.mergeFieldsForm.addControl('applicationNumber', applicationNumberControl)
    }

    ngOnInit() {
        this.chiefsOrderInstanceId = this.activeRoute.snapshot.params['chiefsOrderInstanceId'];

        this.loader.toggleLoader(true);
        if (this.chiefsOrderInstanceId != "" && this.chiefsOrderInstanceId != null && this.chiefsOrderInstanceId != undefined) {
            var chiefsOrderInstance$ = this.chiefsOrderService.getChiefsOrderContext(this.chiefsOrderInstanceId).pipe(
                tap((chiefsOrderContext) => {
                    this.coInfo = chiefsOrderContext;
                    //Fetching by id should only return one item
                    if (chiefsOrderContext && chiefsOrderContext.id == this.chiefsOrderInstanceId) {
                        this.categoryCode = chiefsOrderContext.data.categoryCode;
                        this.priorChiefsOrderNumber = chiefsOrderContext.data.priorChiefsOrderNumber;
                        this.finalStatusForPriorChiefsOrder = chiefsOrderContext.data.statusAssignedToPriorChiefsOrderUponCompletion;
                        this.reportTemplate = {
                            id: chiefsOrderContext.data.templateId,
                            name: chiefsOrderContext.data.templateName,
                            reportContextValues: chiefsOrderContext.data.fields,
                            categoryCode: chiefsOrderContext.data.categoryCode,
                            onBaseDocumentTypeName: chiefsOrderContext.data.documentTypeName,
                            typeCode: "co",
                        } as ReportTemplate;
                        this.mergeInfo = deepClone(this.reportTemplate.reportContextValues);
                        this.org = chiefsOrderContext.data.orgInfo;
                        this.applicationNumber = this.org.applicationNumber;
                        let applicationNumberControl = this.mergeFieldsForm.get('applicationNumber');
                        if (applicationNumberControl)
                            applicationNumberControl.setValue(this.applicationNumber);
                        this.titleText = chiefsOrderContext.data.templateName;
                        this.subHeaderService.updateSubHeader(this.subHeader);
                    }
                    this.createCtrlBindInputs();
                    this.loader.toggleLoader(false);
                }),
                finalize(() => { this.sub.push(chiefsOrderInstance$); })).subscribe(() => { }, (error) => { console.error(error); this.loader.toggleLoader(false); });
        }
        else {
            this.reportTemplate = this.activeRoute.snapshot.data['mergeInfo'];
            this.mergeInfo = deepClone(this.reportTemplate.reportContextValues);
            this.org = this.activeRoute.snapshot.data['orgInfo'];
            this.categoryCode = this.activeRoute.snapshot.params['categoryCode'];

            this.priorChiefsOrderNumber = this.activeRoute.snapshot.params['priorChiefsOrderNumber'];
            this.finalStatusForPriorChiefsOrder = this.activeRoute.snapshot.params['finalStatusForPriorChiefsOrder'];

            this.applicationNumber = this.org.applicationNumber;
            this.mergeFieldsForm.get('applicationNumber').setValue(this.applicationNumber);
            this.createCtrlBindInputs();

            this.titleText = this.reportTemplate.name;

            this.subHeaderService.updateSubHeader(this.subHeader);
            this.loader.toggleLoader(false);
        }       
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy() {
        this.sub.forEach(s => s.unsubscribe());
    }     

    createCtrlBindInputs(): void {
        if (this.mergeInfo.length > 0) {
            for (let value of this.mergeInfo.values()) {
                switch (value.contextValue) {
                    case ChiefsOrderMergeConstants.OrgId.contextValue: value.replaceValue = this.org.organizationId; break;
                    case ChiefsOrderMergeConstants.OrgName.contextValue: value.replaceValue = this.org.organizationName; break;
                    case ChiefsOrderMergeConstants.OrgAddress.contextValue: value.replaceValue = this.org.address.street; break;
                    case ChiefsOrderMergeConstants.OrgCity.contextValue: value.replaceValue = this.org.address.city; break;
                    case ChiefsOrderMergeConstants.OrgState.contextValue: value.replaceValue = this.org.address.stateCode; break;
                    case ChiefsOrderMergeConstants.OrgZip.contextValue: value.replaceValue = this.org.address.zipCode; break;
                    case ChiefsOrderMergeConstants.PriorChiefsOrderNumber.contextValue: value.replaceValue = this.priorChiefsOrderNumber; break;
                    default: {
                        break;
                    }
                }

                let formControl = value.replaceValue != value.contextValue ? new FormControl(value.replaceValue) : new FormControl('');

                if (value.systemProvided)
                    formControl.disable();

                this.mergeFieldsForm.addControl('' + value.displayName + '', formControl);
            }
        }
    }

    public onNextClick(): void {
        this.nextDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.nextDialog);
    }

    public onNextDialogConfirm(): void {
        this.redirectToLetter();
    }


    public onNextDialogCancel(): void {

    }

    redirectToLetter(): void {

        this.loader.toggleLoader(true);
        const add: Address = {
            street: this.org.address.street,
            city: this.org.address.city,
            stateCode: this.org.address.stateCode,
            zipCode: this.org.address.zipCode,
            suite: '',
            poBox:''
        }

        const orginfo: mergeFieldsOrgInfo = {
            applicationNumber: this.org.applicationNumber,
            organizationId: this.org.organizationId,
            organizationName: this.org.organizationName,
            address: add,
        };     

        for (let value of this.mergeInfo.values())
        {            
            //Only try to replace if it exists
            if (this.mergeFieldsForm.get('' + value.displayName + '')) {
                if (this.mergeFieldsForm.get('' + value.displayName + '').value !== '') {
                    value.replaceValue = this.mergeFieldsForm.get('' + value.displayName + '').value;
                }
            }
            else {
                console.warn("The template doesn't contain the following substring to replace:" + value.displayName + ". It was ignored.");
            }
        }

        let fields: IReportContextValue[] = [...this.mergeInfo];

        this.coInfo.data.editedLetter = this.letter;
        this.coInfo.data.categoryCode = this.categoryCode;
        this.coInfo.data.documentTypeName = this.reportTemplate.onBaseDocumentTypeName;
        this.coInfo.data.fields = fields;
        this.coInfo.data.orgInfo = orginfo;
        this.coInfo.data.priorChiefsOrderNumber = this.priorChiefsOrderNumber;
        this.coInfo.data.statusAssignedToPriorChiefsOrderUponCompletion = this.finalStatusForPriorChiefsOrder;
        this.coInfo.data.nextLevelOfReviewRequiresGroupSelection = false;
        this.coInfo.data.templateId = this.reportTemplate.id;
        this.coInfo.data.templateName = this.reportTemplate.name;

        var obj2$ = this.chiefsOrderService.saveMergeFields(this.coInfo).pipe(finalize(() => {
            this.sub.push(obj2$);
        })).subscribe(result => {
            this.loader.toggleLoader(false);
            if (result) {                
                var coid = result;
                if (window.sessionStorage) {
                    window.sessionStorage.setItem('coInfo', JSON.stringify(this.coInfo));
                }
                this.router.navigate(['/admin/chief-orders/co-approve-letter', coid]);
            }
        }, error => {
                console.log('failed to save...' + error);
                this.loader.toggleLoader(false);
        });

    }

}
